import React, { useEffect, useState } from 'react';
import { getIncomeTaxDocument } from '../../business/incomeTax';
import exameLogo from '../../images/Logotipo_ExameSaintPaul_Preto-scaled.png';

const HEADER_HEIGHT = 68;

const styles = {
  page: { height: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif' },
  header: {
    backgroundColor: '#1f2d3d',
    padding: '0 32px',
    height: HEADER_HEIGHT,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  },
  headerLogo: { height: 38, display: 'block' },
  headerDivider: { width: 1, height: 30, backgroundColor: 'rgba(255,255,255,0.35)', flexShrink: 0 },
  headerTitle: { color: '#ffffff', margin: 0, fontSize: 24, fontWeight: 400, lineHeight: 1, letterSpacing: 0.2 },
  alerts: { padding: '32px', backgroundColor: '#f5f5f5' },
};

const InformeRendimentos = ({ match }) => {
  const [status, setStatus] = useState('loading');
  const [presignedUrl, setPresignedUrl] = useState(null);
  const [year, setYear] = useState(null);

  useEffect(() => {
    const { cpf, hash } = match.params;

    if (!cpf || !hash) {
      setStatus('invalid');
      return;
    }

    getIncomeTaxDocument(cpf, hash)
      .then(({ presignedUrl: url, year: yr }) => {
        setPresignedUrl(url);
        // O banco armazena o ano-calendário; exibimos o ano-exercício (calendário + 1)
        setYear(yr ? yr + 1 : null);
        setStatus('success');
      })
      .catch((err) => {
        const code = err.response && err.response.status;
        setStatus(code === 404 ? 'not-found' : 'error');
      });
  }, [match.params.cpf, match.params.hash]);

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <img src={exameLogo} alt="Exame | Saint Paul" style={styles.headerLogo} />
        <div style={styles.headerDivider} />
        <h1 style={styles.headerTitle}>Informe de Rendimentos</h1>
      </div>

      {status === 'loading' && <p style={styles.alerts}>Carregando documento...</p>}

      {(status === 'not-found' || status === 'invalid') && (
        <div style={styles.alerts}>
          <div className="alert alert-warning" role="alert">
            <strong>Link inválido ou não encontrado.</strong>{' '}
            Verifique o endereço e tente novamente.
          </div>
        </div>
      )}

      {status === 'error' && (
        <div style={styles.alerts}>
          <div className="alert alert-danger" role="alert">
            <strong>Erro ao carregar o documento.</strong> Tente novamente mais tarde.
          </div>
        </div>
      )}

      {status === 'success' && presignedUrl && (
        <iframe
          src={presignedUrl}
          title="Informe de Rendimentos"
          style={{ flex: 1, width: '100%', border: 'none', display: 'block' }}
        />
      )}
    </div>
  );
};

export default InformeRendimentos;
